/**
 * DOM Utilities 
 */
class DOMUtility_JS {
    /**
     * Create HTML object from String.
     * @param {String} pTemplate Text HTML Template.
     * @returns {HTMLElement} 
     * @example
     *  const htmElem = DOMUtility_JS.createHTMLFromString('<p>Literal HTML</p>')
     *  htmElem.textContent = 'inner content';
     *  console.log(htmElem.outerHTML);
     * //Output: <p>inner content</p>
     */
    static createHTMLFromString(pTemplate) {
        let objHTMLDiv = document.createElement('DIV'),
            objHTML = null;
        objHTMLDiv.insertAdjacentHTML('afterbegin', pTemplate);
        if (!!objHTMLDiv.firstElementChild) {
            objHTML = objHTMLDiv.firstElementChild;
        }
        return objHTML;
    }
    /**
     * Basic HTML decoder.
     * Strip script/html tags.
     * @param {String} pStr encoded HTML string
     * @returns {String} decoded HTML string
     * @example 
     * DOMUtility_JS.decodeHTMLEntities('&lt;p&gt;¡Hola!&lt;&#x2F;p&gt');
     * //output: <p>¡Hola!</p>'
     */
    static decodeHTMLEntities(pStr) {
        if (pStr && typeof pStr === 'string') {
            // strip script/html tags
            pStr = pStr.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            pStr = pStr.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            const HTMLDIV = document.createElement('DIV');
            HTMLDIV.innerHTML = pStr;
            pStr = HTMLDIV.textContent;
            HTMLDIV.remove();
        }
        return pStr;
    }
    /**
     * Basic html encoder.
     * Replace the following characters with html code:
     *  1. & --> &amp;
     *  2. < --> &lt;
     *  3. > --> &gt;
     *  4. " --> &quot;
     *  5. ' --> &#039;
     *  6. / --> &#x2F;
     *  7. space --> &nbsp;
     * @param {String} pStr Original HTML string. 
     * @returns {String} Sanitized string.
     * @example
     * DOMUtility_JS.encodeHTMLEntities('<p>¡Hola!</p>');
     * // output: &lt;p&gt;¡Hola!&lt;&#x2F;p&gt;
     */
    static encodeHTMLEntities(pStr) {
        return pStr
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
            .replace(/\//g, '&#x2F;')
            // .replace(/\s/g, '&nbsp;')
            .trim();
    }
}
/**
 * Utilities
 */
class Utility_JS {
    /**
     * It’s a pipe flowing left-to-right, calling each function with the output of the last one.
     * @param  {...Function} fns functions
     * @returns {any} outcome
     */
    static pipe(...fns) {
        return (x) => fns.reduce((prevValue, currentFn) => currentFn(prevValue), x);
    }
    /**
     * It’s a pipe flowing right-to-left, calling each function with the output of the last one.
     * @param  {...Function} fns functions
     * @returns {any} outcome
     */
    static compose(...fns) {
        return (x) => fns.reduceRight((prevValue, currentFn) => currentFn(prevValue), x);
    }
    /**
     * Rigth inner join two objects
     * @param {Object} src source object
     * @param {Object} tgt target object
     * @returns {Object} updated target
     */
    static assign(src, tgt) {
        const primitiveType = ['string', 'number', 'boolean'];

        //Assign non valid arrays or objects
        if (primitiveType.some(t => typeof src === t) || tgt === null || tgt === undefined || src === null || src === undefined || typeof src !== typeof tgt) {
            tgt = src;
            return tgt;
        }

        //handle arrays
        if (Array.isArray(src) && Array.isArray(tgt)) {
            src.forEach((ele, ix) => {
                if (primitiveType.some(t => typeof ele === t)) {
                    tgt[ix] = ele
                } else {
                    tgt[ix] = Utility.assign(ele, tgt[ix]);
                }
            });
        }

        //handle objects
        if (typeof src === 'object') {
            for (const key in src) {
                if (tgt.hasOwnProperty(key)) {
                    //assign value
                    if (primitiveType.some(t => typeof src[key] === t)) {
                        tgt[key] = src[key];
                    } else if (Array.isArray(tgt[key]) && Array.isArray(src[key])) {
                        //decompose array
                        src[key].forEach((ele, ix) => {
                            if (primitiveType.some(t => typeof ele === t)) {
                                tgt[key][ix] = ele
                            } else {
                                tgt[key][ix] = Utility.assign(ele, tgt[key][ix]);
                            }
                        });
                    } else {
                        //decompose object
                        tgt[key] = Utility.assign(src[key], tgt[key]);
                    }
                } else {
                    tgt[key] = src[key];
                }
            }
        }
        return tgt;
    }
}
/**
 * Helper methods for string formatting.
 */
class Formatter_JS{
/**
   * Edit Time in (HH:MM:ss) format from seconds.
   * @param {Number} seconds
   * @returns {string} output HH:MM:ss
   */
static formatDuration(seconds) {
    const _seconds = Math.floor(seconds % 60),
          _minutes = Math.floor(seconds / 60) % 60,
          _hours = Math.floor(seconds / 3600),
          _leadingZeroFormatter = new Intl.NumberFormat(undefined, {minimumIntegerDigits: 2,});
    if (_hours === 0) {
            return `${_minutes}:${_leadingZeroFormatter.format(_seconds)}`;
        } else {
            return `${_hours}:${_leadingZeroFormatter.format(_minutes)}:${this._leadingZeroFormatter.format(_seconds)}`;
        }
    }
}